import { NgTemplateOutlet } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { UnreportedOutageHelpComponent } from '../unreported-outage-help/unreported-outage-help.component';

@Component({
  selector: 'app-info-error-status',
  imports: [NgTemplateOutlet, UnreportedOutageHelpComponent],
  templateUrl: './info-error-status.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InfoErrorStatusComponent {}
